<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import {formatDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import NotificationPreviewModal from "./NotificationPreviewModal.svelte";

    const pageHeaderControls = [
        {key: 'check', name: 'ΕΛΕΓΧΟΣ'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'subject', title: 'ΤΙΤΛΟΣ', sortable: true, sort_way: 'ASC'},
        {key: 'recipient', title: 'ΠΑΡΑΛΗΠΤΗΣ', sortable: true},
        {key: 'type', title: 'ΕΙΔΟΣ', sortable: false},
        {key: 'status', title: 'ΚΑΤΑΣΤΑΣΗ', sortable: true},
        {key: 'service_expire_at', title: 'ΛΗΞΗ', sortable: true},
        {key: 'created_at', title: 'ΗΜΕΡΟΜΗΝΙΑ', sortable: true},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    const types = {
        0: '1η ειδοποίηση',
        1: '2η ειδοποίηση',
        2: 'Λήξη',
        3: 'Ανανέωση'
    };

    const statuses = {
        0: '',
        1: 'Παύση',
        2: 'Απεστάλη',
        3: 'Σφάλμα'
    };


    let notifications = null;
    let notificationId = null;
    let previewId = null;
    let search = {};


    const load = async (loader = LOADER.PAGE) => {

        const onSuccess = result => {
            notifications = result;
        }

        const onFailure = err => {
        };

        await R.handle(R.notification.index, search, onSuccess, onFailure, loader);
    };

    const check = async () => {
        const onSuccess = result => {
            if (result.total_new > 0) {
                load();
                Notifier.showMessage(`Βρέθηκαν ${result.total_new} ειδοποιήσεις`);
            } else {
                Notifier.showMessage(`Δεν βρέθηκαν ειδοποιήσεις`);
            }
        }

        const onFailure = err => {
        };

        await R.handle(R.notification.check, {}, onSuccess, onFailure, LOADER.PAGE);
    }


    const onDelete = notification => {

        const onSuccess = result => {
            notifications = notifications.filter(x => x.id != result);
            Notifier.showMessage("Η ειδοποίηση διαγράφτηκε");
        }

        const onFailure = err => {
        };

        Alert.delete("Διαγραφή", `Να διαγραφεί η ειδοποίηση "${notification.subject}";`, () => {
            R.handle(R.notification.delete, notification.id, onSuccess, onFailure, LOADER.POPUP);
        });
    }

    const onColumnSort = ({detail: column}) => {
        search.sort_field = column.key;
        search.sort_way = column.sort_way;
        load(LOADER.POPUP);
    };

    const onSend = notification => {
        const onSuccess = result => {
            let item = notifications.find(x => x.id == result.id);
            if (item) {
                item.status = ~~result.status;
                item.error = result.error;
            }
            notifications = notifications;

            if (item.status === 3) {
                Notifier.showError("Η αποστολή της ειδοποίησης απέτυχε!");
                return;
            }

            if (item.status === 2) {
                Notifier.showMessage("Η αποστολή της ειδοποίησης ολοκληρώθηκε");
            }
        }

        const onFailure = err => {
        };

        Alert.confirm("Αποστολή", `Να γίνει αποστολή της ειδοποίησης "${notification.subject}";`, () => {
            R.handle(R.notification.send, notification.id, onSuccess, onFailure, LOADER.POPUP);
        });
    }

    const openPreview = notification => {
        previewId = notification.id;
        notificationId = notification.id;
    }

    const closePreview = () => {
        previewId = null;
    }

    load();
</script>

<PageHeader title="Ειδοποιήσεις" controls={ pageHeaderControls } on:reload={ load } on:check={check}/>

<div class="panel">
    <div class="panel-body">
        {#if notifications}
            {#if notifications.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each notifications as item}
                        <tr class="row-hover" class:row-selected="{ notificationId === item.id }">
                            <td>
                                <button class="btn-reset btn-block is-link"
                                        on:click="{ () => openPreview(item) }">
                                    { item.subject }
                                </button>
                            </td>
                            <td class="text-gray">
                                { item.recipient }
                            </td>
                            <td class="text-gray">
                                { types[item.notification_type] }
                            </td>
                            <td class="text-gray">
                                { statuses[item.status] }
                            </td>
                            <td class="text-gray">
                                {formatDate(item.service_expire_at, 'd-m-y')}
                            </td>
                            <td class="date-column text-gray">
                                { formatDate(item.created_at, 'd-m-y') }
                            </td>
                            <td class="button-column">
                                <button class="button" title="αποστολή" on:click="{ () => onSend(item) }">
                                    <AppIcon icon="email"/>
                                </button>
                            </td>
                            <td class="button-column">
                                <button class="button" title="διαγραφή" on:click="{ () => onDelete(item) }">
                                    <AppIcon icon="trash"/>
                                </button>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {:else}
                <div class="panel-pad">
                    Δεν υπάρχουν ειδοποιήσεις
                </div>
            {/if}
        {/if}
    </div>
</div>

{#if previewId}
    <NotificationPreviewModal notificationId={previewId} closeCallback={closePreview}/>
{/if}
